import React, { useEffect, useRef } from "react";
import "./our-equipment.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import ButtonFx from "components/common/button-fx";

const equipment = [
  {
    title: "Arrow Boards",
    image: "/images/traffic/arrow-board.jpg",
    link: "/services/arrow-boards/",
  },
      {
    title: "Light Tower",
    image: "/images/traffic/light-tower.jpeg",
    link: "/services/light-tower/",
  },
  {
    title: "Highway Trucks",
    image: "/images/traffic/highway-truck.jpg",
    link: "/services/highway-trucks/",
  },
  {
    title: "Portable Traffic Lights",
    image: "/images/traffic/portable-traffic-lights.jpg",
    link: "/services/portable-traffic-lights/",
  },
  {
    title: "Traffic Utes",
    image: "/images/traffic/traffic-ute.jpeg",
    link: "/services/traffic-utes/",
  },
  {
    title: "Travel Times",
    image: "/images/traffic/travel-times.jpeg",
    link: "/services/travel-times/",
  },
  {
    title: "TMA's",
    image: "/images/traffic/tmas.jpeg",
    link: "/services/truck-mounted-attenuators/",
  },
  {
    title: "Variable Speed Limit Signs",
    image: "/images/traffic/variable-speed-limit-signs.jpg",
    link: "/services/variable-speed-limit-signs/",
  },
  {
    title: "VMS Boards",
    image: "/images/traffic/message-boards.jpeg",
    link: "/services/vms-boards/",
  },
  {
    title: "VMS Utes",
    image: "/images/traffic/vms-ute.jpg",
    link: "/services/vms-utes/",
  },
  {
    title: "Portaboom",
    image: "/images/traffic/portaboom.jpg",
    link: "/services/portaboom/",
  },

];

const OurEquipment = () => {
  const sliderRef = useRef(null);
  const history = useHistory();
  const isPaused = useRef(false);

  const scroll = (direction) => {
    const slider = sliderRef.current;

    if (!slider) return;

    const card = slider.querySelector(".equipment-card");

    if (!card) return;

    const cardWidth = card.offsetWidth;
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    if (direction === "right") {
      // If at the end, return to the beginning
      if (slider.scrollLeft >= maxScroll - cardWidth / 2) {
        slider.scrollTo({
          left: 0,
          behavior: "smooth",
        });
      } else {
        slider.scrollBy({
          left: cardWidth,
          behavior: "smooth",
        });
      }
    } else {
      // If at the beginning, go to the end
      if (slider.scrollLeft <= 0) {
        slider.scrollTo({
          left: maxScroll,
          behavior: "smooth",
        });
      } else {
        slider.scrollBy({
          left: -cardWidth,
          behavior: "smooth",
        });
      }
    }
  };

useEffect(() => {
  const interval = setInterval(() => {
    if (!isPaused.current) {
      scroll("right");
    }
  }, 4000);

  return () => clearInterval(interval);
}, []);

  return (
    <section className="our-equipment">
      <div className="our-equipment-title">
        <h2>
          Our <span>Equipment</span>
        </h2>
      </div>

      <div
  className="equipment-slider-wrapper"
  onMouseEnter={() => {
    isPaused.current = true;
  }}
  onMouseLeave={() => {
    isPaused.current = false;
  }}
>
        <button
          type="button"
          className="equipment-arrow equipment-arrow-left"
          onClick={() => scroll("left")}
          aria-label="Previous equipment"
        >
          <i className="fas fa-chevron-left"></i>
        </button>

        <div className="equipment-slider" ref={sliderRef}>
          {equipment.map((item, index) => (
            <div className="equipment-card" key={index}>
              <div className="equipment-image">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="equipment-card-content">
                <h3>{item.title}</h3>

                <ButtonFx
                  className="mt-aqua-mini-button"
                  onClick={() => history.push(item.link)}
                >
                  Learn More
                </ButtonFx>
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="equipment-arrow equipment-arrow-right"
          onClick={() => scroll("right")}
          aria-label="Next equipment"
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </section>
  );
};

export default OurEquipment;